import { createContext } from "react";

import EmailTemplate from "@mapmycustomers/shared/types/email/EmailTemplate";
import {
  Deal,
  EntitiesSupportedByEmailFeature,
  EntityTypesSupportedByEmailFeature,
} from "@mapmycustomers/shared/types/entity";

interface EmailCreationModalState {
  id: string;
  params?:
    | {
        deals?: Deal[];
        recipients: EntitiesSupportedByEmailFeature[];
      }
    | { recipientType: EntityTypesSupportedByEmailFeature }
    | {
        template?: EmailTemplate;
      };
}

export interface EmailsCreationModalsContextValue {
  emailModals: EmailCreationModalState[];
  hideEmailModal(id: string): void;
  showEmailModal(params?: EmailCreationModalState["params"]): string;
}

const CreateEmailModalsContext = createContext<EmailsCreationModalsContextValue | null>(null);

CreateEmailModalsContext.displayName = "CreateEmailModalsContext";

export default CreateEmailModalsContext;
